import { Component, Input, OnInit } from '@angular/core';
import { PerfilRiesgoVariacionCiclo } from '../../../_models/perfil-riesgo-variacion-ciclo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListaItem } from '../../../_models/lista-item';
import { SelectItem } from 'primeng/api';
import { TipoScore } from '../../../_enums/enum';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { NavService } from '../../../_services/_nav.service';
import { PerfilesRiesgosScore } from '../../../_models/perfiles-riesgos-score';
import { PerfilesRiesgosScoreService } from '../../../_services/perfiles-riesgos-score.service';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-asignar-score',
  templateUrl: './asignar-score.component.html',
  styleUrls: ['./asignar-score.component.css']
} )
export class AsignarScoreComponent implements OnInit {
  @Input() perfil: PerfilRiesgo;
  @Input() editando: Boolean = false;
  formulario: FormGroup;
  carInformacionInicial: boolean = true;
  guardando: boolean = false;
  listProveedor: SelectItem[] = [];
  listTipoTemp: ListaItem[] = [];
  listTipo: SelectItem[] = [];
  verValor: boolean = false;
  verRango: boolean = false;
  submitted: boolean = false;
  cargarTable: boolean = true;
  columnas: any[] = [];
  listadoPorPerfilRiesgoScore: PerfilesRiesgosScore[] = [];
  posicion: number;
  errorRango: boolean;
  errorValor: boolean;
  errorDesde: boolean;
  errorHasta: boolean;


  constructor(
    private fb: FormBuilder,
    private listaService: ListaService,
    private navServicio: NavService,
    private conServicio: ConfirmationService,
    private perfilRiesgoScoreService: PerfilesRiesgosScoreService
  ) {
  }

  ngOnInit() {
    this.columnas = [
      { field: 'proveedor', header: this.navServicio.buscarMensaje( 'PERFILRIESGOSCORE.LBL_PROVEEDOR' ), sort: false },
      { field: 'tipo', header: this.navServicio.buscarMensaje( 'PERFILRIESGOSCORE.LBL_TIPO' ), sort: false },
      { field: 'valor', header: this.navServicio.buscarMensaje( 'PERFILRIESGOSCORE.LBL_VALOR' ), sort: false },
      { field: 'desde', header: this.navServicio.buscarMensaje( 'PERFILRIESGOSCORE.LBL_DESDE' ), sort: false },
      { field: 'hasta', header: this.navServicio.buscarMensaje( 'PERFILRIESGOSCORE.LBL_HASTA' ), sort: false }
    ];
    if ( !this.editando )
    {
      this.columnas.push({ field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false });
    }
    forkJoin(
      this.listaService.getMasterDetails( 'ListasProveedoresScore' ),
      this.listaService.getMasterDetails( 'ListasTiposScore' )
    ).subscribe( ( [listaProveedores, lista] ) => {
      listaProveedores.forEach( l => {
        this.listProveedor.push( { label: l.nombre, value: l.idLista } );
      } );
      this.listTipoTemp = lista;
      lista.forEach( l => {
        this.listTipo.push( { label: l.nombre, value: l.idLista } );
      } );
      this.cargarTabla();
      this.cargarFormulario();
    }, error => {
      this.navServicio.setMesage( 0, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información.'
      } );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPerfilRiesgoScore: [null, []],
      idPerfilRiesgo: [this.perfil.idPerfilRiesgo, []],
      idProveedorScore: [null, [Validators.required]],
      idTipoScore: [null, [Validators.required]],
      valor: [null, [Validators.required]],
      desde: [null, []],
      hasta: [null, []],
      indicadorHabilitado: [true, []],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.errorDesde && !this.errorHasta) {
      const _data = this.formulario.getRawValue();
      const _validador = this.verRango ?
        await this.perfilRiesgoScoreService.verificarRangoConProveedor(_data.idProveedorScore, _data.desde, _data.hasta, _data.idPerfilRiesgoScore).toPromise()
        : await this.perfilRiesgoScoreService.verificarValorConProveedor(_data.idProveedorScore, _data.valor).toPromise();
      const _nombreTipo = this.listTipoTemp.find( l => l.idLista === _data.idTipoScore );
      if (!_validador || (_validador.estado ||  _validador.idPerfilRiesgoScore === _data.idPerfilRiesgoScore)  && !this.errorRango && !this.errorValor) {
        this.guardando = true;
        if ( _data.idPerfilRiesgoScore ) {
          const _resp = await this.perfilRiesgoScoreService.actualizar( _data ).toPromise();
          _resp.tipoScore = _nombreTipo ? _nombreTipo.nombre : '';
          this.listadoPorPerfilRiesgoScore[ this.posicion ] = _resp;
          this.navServicio.setMesage(2);
          this.limpiar();
          this.cargarTabla();
        } else {
          const _resp = await this.perfilRiesgoScoreService.guardar( _data ).toPromise();
          _resp.tipoScore = _nombreTipo ? _nombreTipo.nombre : '';
          this.listadoPorPerfilRiesgoScore.push( _resp );
          this.navServicio.setMesage(2);
          this.limpiar();
          this.cargarTabla();
        }
      } else {
        this.errorRango = true;
        this.errorValor = true;
      }
    }
  }

  cambiarTipo() {
    const _formulario = this.f
    const _buscar_proveedor = _formulario.idProveedorScore.value
    const _buscar_tipoScore = this.listTipoTemp.find( l => l.idLista === _formulario.idTipoScore.value );

    if ( _buscar_proveedor && _buscar_tipoScore && _buscar_tipoScore.codigo === TipoScore.RANGO ) {
      this.verRango = true;
      this.verValor = false;
      _formulario.valor.setValidators( [] );
      _formulario.valor.setErrors( null );
      _formulario.valor.setValue( '' );
      _formulario.desde.setValidators( [Validators.required] );
      _formulario.hasta.setValidators( [Validators.required] );
    } else if (_buscar_proveedor && _buscar_tipoScore && _buscar_tipoScore.codigo === TipoScore.VALOR) {
      this.verValor = true;
      this.verRango = false;
      _formulario.hasta.setValidators( [] );
      _formulario.desde.setValidators( [] );
      _formulario.hasta.setErrors( null );
      _formulario.desde.setErrors( null );
      _formulario.hasta.setValue( null );
      _formulario.desde.setValue( null );
      _formulario.valor.setValidators( [Validators.required] );
    }
  }

  limpiar() {
    this.submitted = false;
    this.verValor = false;
    this.verRango = false;
    this.formulario.reset();
    this.f.idPerfilRiesgo.setValue(this.perfil.idPerfilRiesgo);
    this.posicion = null;
    this.guardando = false;
  }

  editar( data: PerfilesRiesgosScore, posicion: number ) {
    this.limpiar()
    this.f.idPerfilRiesgoScore.setValue( data.idPerfilRiesgoScore );
    this.f.idPerfilRiesgo.setValue( data.idPerfilRiesgo );
    this.f.idProveedorScore.setValue( data.idProveedorScore );
    this.f.idTipoScore.setValue( data.idTipoScore );
    this.f.valor.setValue( data.valor );
    this.f.desde.setValue( data.desde );
    this.f.hasta.setValue( data.hasta );
    this.f.indicadorHabilitado.setValue( data.indicadorHabilitado );
    this.cambiarTipo();
    this.posicion = posicion;
  }

  eliminar( data: PerfilesRiesgosScore, posicion: number ) {
    this.conServicio.confirm({
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      message: this.navServicio.buscarMensaje('PERFILRIESGOSCORE.MSG_CONFELIMINAR'),
      key: 'score',
      accept: () => {
        data.indicadorHabilitado = false;
        this.perfilRiesgoScoreService.actualizar(data).subscribe( resp => {
          this.listadoPorPerfilRiesgoScore.splice(posicion, 1);
          this.navServicio.setMesage(0, {
            severity: 'success',
            summary: 'Éxito',
            detail: this.navServicio.buscarMensaje('PERFILRIESGOSCORE.MSG_ELIMINAR')
          });
          this.limpiar();
          this.cargarTabla();
        });
      },
      reject: () => {}
    });
  }

  validarDesde(desde: number) {
    if (this.f.hasta.value && Number(desde) > Number(this.f.hasta.value)) {
      this.errorDesde = true;
      this.errorHasta = true;
      this.errorRango = false;
    } else if (this.f.hasta.value && Number(desde) === Number(this.f.hasta.value)) {
      this.errorRango = true;
    } else {
      this.errorRango = false;
      this.errorDesde = false;
      this.errorHasta = false;
      this.errorValor = false;
    }
  }

  validarHasta(hasta: number) {
    if (this.f.desde.value && Number(hasta) < Number(this.f.desde.value)) {
      this.errorHasta = true;
      this.errorDesde = true;
      this.errorRango = false;
    } else if (this.f.desde.value && Number(hasta) === Number(this.f.desde.value)) {
      this.errorRango = true;
    } else {
      this.errorHasta = false;
      this.errorRango = false;
      this.errorDesde = false;
      this.errorValor = false;
    }
  }

  reloadErrorValor() {
    this.errorValor = false;
    this.errorRango = false;
  }

  cargarTabla() {
    this.carInformacionInicial = true;
    this.cargarTable = true;
    return this.perfilRiesgoScoreService.obtenerPorPerfilRiesgo( this.perfil.idPerfilRiesgo ).subscribe(listadoPorPerfilRiego => {
      this.listadoPorPerfilRiesgoScore = listadoPorPerfilRiego;
      this.carInformacionInicial = false;
      this.cargarTable = false;
    });
  }

  cancelar(cambio: boolean) {
    if (cambio) {
      this.conServicio.confirm({
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        message: this.navServicio.buscarMensaje('PERFILRIESGOSCORE.MSG_CANCELAR'),
        key: 'score',
        accept: () => {
          this.limpiar();
        },
        reject: () => {}
      });
    } else {
      this.limpiar();
    }
  }

}
